import { Box } from '@src/atoms/Box';
import React, { FC, useState } from 'react';

import styled from './BundleCard.module.scss';
import { BundleButtons } from './_BundleButtons/BundleButtons';
import { MainBonus } from './_MainBonus/MainBonus';
import { BonusesDescription } from './_BonusesDescription/BonusesDescription';
import { BundleBody } from './_BundleBody/BundleBody';
import { TColorNew } from '@src/models/colors';
import { TColor } from '@src/models/common';
import { IMediaFile } from '@src/models/api';
import { IProduct } from '@src/models/entities';
import { ImageRenderer } from '@src/atoms/ImageRenderer';

export interface IBundleCardProps {
  isMulti?: boolean;
  title: string;
  description: string;
  budget: string;
  discount: string;
  mainBonus?: string;
  bonusesDescription?: string[];
  bundleIcon: IMediaFile;
  bundleColorName?: TColorNew | TColor;
  buttonCb: () => void;
  mainButtonText: string;
  arrowBonus?: boolean;
  includedProductsLogos?: IProduct[];
  width?: number;
  minHeight?: number;
  isWide?: boolean;
}

export const BundleCard: FC<IBundleCardProps> = ({
  isMulti,
  title,
  description,
  budget,
  discount,
  mainBonus,
  bonusesDescription,
  bundleIcon,
  bundleColorName,
  buttonCb,
  mainButtonText,
  arrowBonus,
  includedProductsLogos,
  width,
  minHeight,
  isWide,
}) => {
  const [isShowBonuses, setIsShowBonuses] = useState(false);
  const handleShowBonuses = () => {
    setIsShowBonuses(!isShowBonuses);
  };
  const getGap = () => {
    if (!arrowBonus && !isMulti) {
      return 16;
    }
    if (isWide) {
      return 24;
    }
    return 50;
  };
  return (
    <Box className={styled.root} bgColor={'basicWhite'} padding={24} fullWidth gap={24}>
      {isWide && (
        <Box className={styled.logoContainer}>
          <ImageRenderer url={bundleIcon.mainUrl} width={64} height={64} />
        </Box>
      )}
      <Box
        bgColor={'basicWhite'}
        column
        justifyContent={'spaceBetween'}
        style={{ width, minHeight, gap: getGap() }}
        fullWidth
      >
        {isShowBonuses ? (
          <BonusesDescription bonusesDescription={bonusesDescription} />
        ) : (
          <Box column gap={32}>
            <BundleBody
              title={title}
              description={description}
              budget={budget}
              discount={discount}
              bundleIcon={bundleIcon.mainUrl}
              bundleColor={bundleColorName}
              mainBonus={mainBonus}
              bonusesCount={bonusesDescription?.length}
              isMulti={isMulti}
              arrowBonus={arrowBonus}
              includedProductsLogos={includedProductsLogos}
              isWide={isWide}
            />
            {!arrowBonus && (
              <MainBonus mainBonus={mainBonus} bonusesCount={bonusesDescription?.length} isMulti={isMulti} />
            )}
          </Box>
        )}
        <BundleButtons
          isShowBonuses={isShowBonuses}
          handleShowBonuses={handleShowBonuses}
          bonusesCount={bonusesDescription?.length}
          isMulti={isMulti}
          buttonCb={buttonCb}
          mainButtonText={mainButtonText}
          arrowBonus={arrowBonus}
          isWide={isWide}
        />
      </Box>
    </Box>
  );
};
